import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    fontSize: 10,
  },
});

export default function LimitOrderTextFields({
  limitOrder,
  dispatchLimitOrder,
}) {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState(limitOrder.limitPrice);
  useEffect(() => {
    setInputValue(limitOrder.limitPrice);
  }, [limitOrder]);
  return (
    <>
      {/* <TextField
            className={classes.root}
            value={inputValue}
            variant="outlined"
            size="small"
            style={{backgroundColor: "white", width: "100%"}}
            onChange={ev => setInputValue(ev.target.value)}
            onBlur={ev => dispatchLimitOrder({offsetFromSetupPrice: parseFloat(ev.target.value)})}
            label={<Typography style={{fontSize: 10}}>offset from current price</Typography>}
            InputProps={{endAdornment: "$"}}
        > < Typography style={{fontSize: 1}}>{inputValue}</Typography></TextField> */}
      <Grid item xs={3}>
        <TextField
          className={classes.root}
          value={inputValue}
          variant="outlined"
          size="small"
          inputProps={{ style: { fontSize: 10 } }}
          style={{ backgroundColor: "white", width: "100%" }}
          onChange={(ev) => setInputValue(ev.target.value)}
          onBlur={(ev) =>
            dispatchLimitOrder({ limitPrice: parseFloat(ev.target.value) })
          }
          label={<Typography style={{ fontSize: 10 }}>limit price</Typography>}
          InputProps={{ endAdornment: "$" }}
        >
          {" "}
          <Typography style={{ fontSize: 1 }}>{inputValue}</Typography>
        </TextField>
      </Grid>
    </>
  );
}
